import { apiClient } from './apiClient';
import type {
  ManualJobEndAssignment,
  ManualJobEndResult,
  GenerateManualJobEndRequest,
} from './types/manualJobEnd.types';

// The person picker reuses the OCCer staff search (occerSearchApi.getActiveStaff) — see WI #1103.
export const manualJobEndApi = {
  getAssignments: async (staffId: number): Promise<ManualJobEndAssignment[]> => {
    const response = await apiClient.get<ManualJobEndAssignment[]>(
      `/manual-job-ends/staff/${staffId}/assignments`,
    );
    return response.data;
  },

  generate: async (request: GenerateManualJobEndRequest): Promise<ManualJobEndResult> => {
    const response = await apiClient.post<ManualJobEndResult>('/manual-job-ends', request);
    return response.data;
  },
};

export default manualJobEndApi;
